module.exports = __webpack_public_path__ + "static/media/majorD4.47597bb.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorD4.wav
// module id = 8RU4
// module chunks = 0